const GA_TRACKING_ID = 'G-9F481QJL59';

export const pageview = (url) => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};

export default pageview;
